export default __webpack_public_path__ + "static/media/Traits and rarities.7eba04b1.jpg";